import styled from 'styled-components';

export const HomePageWrapperStyled = styled.div``;

export const BuyButtonStyled = styled.button``;
